import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { Address, AddressData } from "@/types/index";
import { useUserStore } from "@/stores/userStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'KakaoAddressModal',
  emits: ["updateAddress", "onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const emit = __emit;

const userStore = useUserStore();

const daumPostcode = ref<HTMLElement | null>(null);

const insertAddress = async (addressData: AddressData) => {
  const coordinate = await userStore.getAddressCoordinate(
    addressData.roadAddress || addressData.autoRoadAddress
  );
  const address: Address = {
    zipNo: addressData.zonecode,
    dongNo: addressData.bcode,
    dongAddress: addressData.jibunAddress || addressData.autoJibunAddress,
    roadNo: addressData.roadnameCode,
    roadAddress: addressData.roadAddress || addressData.autoRoadAddress,
    detailAddress: "",
    lat: coordinate?.data?.latitude || 0,
    lng: coordinate?.data?.longitude || 0,
  };
  emit("updateAddress", address);
  closeDaumPostcode();
};

const closeDaumPostcode = () => {
  emit("onClickClose");
};

const openDaumPostcode = () => {
  new window.daum.Postcode({
    oncomplete: (address: AddressData) => {
      // 검색결과 항목을 클릭했을때 실행할 코드를 작성하는 부분.
      // 각 주소의 노출 규칙에 따라 주소를 조합한다.
      // 내려오는 변수가 값이 없는 경우엔 공백('')값을 가지므로, 이를 참고하여 분기 한다.
      insertAddress(address);
    },
    width: "100%",
    height: "100%",
  }).embed(daumPostcode.value);
};

onMounted(() => {
  openDaumPostcode();
});

const __returned__ = { emit, userStore, daumPostcode, insertAddress, closeDaumPostcode, openDaumPostcode, NavigationBar }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})